import { withTopbarProps } from '@jusbrasil/topbar'
import { withApollo } from '@jusbrasil-web/core-apollo'
import { DevIndexPage } from '@jusbrasil-web/core-next'
import { withUserSession } from '@jusbrasil-web/shared-user-session'
import { GetServerSideProps } from 'next'

/* eslint-disable-next-line @typescript-eslint/no-empty-interface */
export interface IndexPageProps {}

export function IndexPage(props: IndexPageProps) {
  return (
    <DevIndexPage
      title="Docview"
      subtitle="Documentos de artefatos Jusbrasil"
      pages={{
        '/jurisprudencia/tj-ce/1373977851/inteiro-teor-1373977855': 'Juris de 1º grau',
        '/jurisprudencia/tj-rj/1478831127': 'Juris de 2º grau',
        '/jurisprudencia/stj/433538550': 'Juris de grau superior com anexos',
        '/jurisprudencia/stf/1301456470': 'Juris de grau superior com temas e teses',
        '/jurisprudencia/tst/orientacoes-jurisprudenciais/orientacao-jurisprudencial-oj-n-269-do-sdi1-do-tst/1627583672':
          'Orientação Jurisprudencial',
        '/jurisprudencia/stj/sumulas/sumula-n-227-do-stj/1289710792': 'Súmula',
        '/corrente-jurisprudencial/2097539783': 'Legislação comentada',
        '/corrente-jurisprudencial/2177621712': 'Jurisprudência em teses',
        '/corrente-jurisprudencial/2518615664': 'Corrente comentada',
        '/modelos-pecas/modelo-de-peticao-inicial-acao-de-indenizacao-por-danos-morais-atualizado-2021/1151841441':
          'Modelo',
        '/artigos/o-o-uma-espiadinha-dentro-do-jusbrasil/383937197': 'Artigo',
        '/topicos/10596143/artigo-84-da-lei-n-8078-de-11-de-setembro-de-1990': 'Tópico',
        '/topicos/10639607/artigo-4-do-decreto-lei-n-2848-de-07-de-dezembro-de-1940':
          'Tópico com resumo estático',
        '/documentos/tema-n-164-do-stf/2746253779': 'Documento genérico - Tema',
        '/noticias/ministro-da-habeas-corpus-para-dispensar-mulher-gravida-de-usar-tornozeleira-eletronica-durante-o-parto/2917374912':
          'Notícia',
        '/processos/576559652/peca-peticao-inicial-tjrn-acao-de-indenizacao-por-danos-morais-danos-a-imagem-c-c-obrigacao-de-fazer-procedimento-do-juizado-especial-civel-2554284998':
          'Peça',
        '/doutrina/secao/apresentacao-das-coordenadoras-desafios-institucionais-da-tributacao-das-operacoes-na-nuvem-tributacao-da-nuvem-conceitos-tecnologicos-desafios-internos-e-internacionais/1207548546':
          'Seção Doutrina',
        '/doutrina/tributacao-da-nuvem-conceitos-tecnologicos-desafios-internos-e-internacionais/1207548541':
          'Doutrina',
        '/legislacao/95552/lei-maria-da-penha-lei-11340-06': 'Legislação',
        '/diarios/285727576/stf-02-03-2020-pg-1': 'Diário',
        '/diarios/documentos/815682280/andamento-do-processo-n-181809-habeas-corpus-02-03-2020-do-stf':
          'Bloco Diário',
      }}
      metadata={{
        Team: '@legal-research-devs',
        Channel: '#team-lr-core',
      }}
    />
  )
}

const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { withApolloProps } = withApollo(ctx)
  return { props: { ...withUserSession(ctx), ...withTopbarProps(ctx), ...withApolloProps() } }
}

export const IndexPageExports = { getServerSideProps }
